export const getLocale = (lng: string) => {
  const locales = {
    ar: import('date-fns/locale/ar-DZ'),
    az: import('date-fns/locale/az'),
    be: import('date-fns/locale/be'),
    de: import('date-fns/locale/de'),
    en: import('date-fns/locale/en-US'),
    es: import('date-fns/locale/es'),
    fr: import('date-fns/locale/fr'),
    he: import('date-fns/locale/he'),
    hy: import('date-fns/locale/hy'),
    ja: import('date-fns/locale/ja'),
    kk: import('date-fns/locale/kk'),
    ky: import('date-fns/locale/ru'),
    ru: import('date-fns/locale/ru'),
    uk: import('date-fns/locale/uk'),
    uz: import('date-fns/locale/uz'),
    zh: import('date-fns/locale/zh-CN'),
    ka: import('date-fns/locale/ka'),
    tr: import('date-fns/locale/tr'),
  };

  const locale = locales[lng] || locales.ru;
  return locale;
};
